export const validateZipCode = (zipCode: string): boolean => {
  const re = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
  return Boolean(zipCode.match(re));
};

export default validateZipCode;
